export const LinkedUrl =
  "https://www.linkedin.com/in/saurav-gaur-ba8a67263?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3B7yib%2BOHgTSC9Eoqj3HFCxQ%3D%3D";
export const GithubUrl = "https://www.github.com/sauravgaur14";
